import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Form, Input, Divider  } from 'antd'
import { showUtilModal } from '../../redux/actions/miscActions'
import { facebookLogin, googleLogin, emailSignIn } from '../../redux/actions/userActions'

export class Login extends Component {
  constructor(props){
    super(props)
    this.state={
      email: '',
      password: ''
    }
  }
  showRegisterComp=()=>{
    this.props.showUtilModal('register')
  }

  handleFacebookLogin=()=>{
    this.props.facebookLogin()
  }

  handleGoogleLogin=()=>{
    this.props.googleLogin()
  }

  handleChange=(e)=>{
    this.setState({
      [e.target.name]: e.target.value
    })
  }

handleEmailLogin=()=>{
  const { email, password } = this.state
this.props.emailSignIn(email, password)
}
  
  render() {
    const { email, password } = this.state
    return (
      <div className="user-login">
        <p>Inloggen met:</p>
        <Form layout="vertical">
        <Form.Item label="Email">
            <Input name='email' onChange={this.handleChange} value={email}/>
          </Form.Item>
        <Form.Item label="Wachtwoord">
            <Input.Password name='password' onChange={this.handleChange} value={password}/>
          </Form.Item>
          <button className="small-main-btn" onClick={this.handleEmailLogin}>Inloggen</button>
        </Form>
        <Divider plain>Of log in met:</Divider>
        <div className="buttons">
          <button onClick={this.handleFacebookLogin} className="facebook-button">
          <i className="fab fa-facebook-f"></i>
          Facebook
          </button>
          <button onClick={this.handleGoogleLogin} className="google-button">
          <i className="fab fa-google"></i>
          Google
          </button>
        </div>
        <p className="register-text">Nog geen account? <span onClick={this.showRegisterComp}>Registreer hier</span></p>
      </div>
    )
  }
}

export default connect(null, { showUtilModal, facebookLogin, googleLogin, emailSignIn  })(Login)
